import { cva } from 'class-variance-authority';

var clazz = cva("h-[inherit] px-3 group-hover/row:hover:bg-blue-307", {
    variants: {
        hover: {
            true: "hover:bg-blue-307"
        },
        border: {
            horizontal: "border-b border-b-gray-204",
            vertical: [
                "first:border-l-0 border-l border-l-gray-204",
                "last:border-r-0 border-r border-r-gray-204",
            ],
            true: [
                "border-b border-b-gray-204",
                "first:border-l-0 border-l border-l-gray-204",
                "last:border-r-0 border-r border-r-gray-204",
            ],
        }
    },
    defaultVariants: {}
});

export { clazz };
